const isStandarLinkInterface=object=>{if(object){return'url'in object;}else{return false;}};export{isStandarLinkInterface};